import { KASPI } from '@/config'
import Cookie from 'js-cookie'

export function getLocale () {
  let locale = KASPI.defaultLocale

  if (KASPI.isMultilanguageEnabled && Cookie.get('locale')) {
    locale = Cookie.get('locale')
  }

  return locale
}
